var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7.66721 9.99661-7.494847-7.32937 2.459477-2.40517 9.95436 9.73454-9.95436 9.73449-2.459477-2.4051z","fill":"#fff"}));
}

ChevronRight.defaultProps = {"fill":"none","height":"20","viewBox":"0 0 13 20","width":"13"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
